import { Category } from '../types';

export function getCategoryName(
  categoryId: string,
  categories: Category[],
  fallbackName?: string
): string {

  return (
    categories.find(
      cat => cat.id === categoryId
    )?.name || fallbackName || 'Categoria'
  );
}
